import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'
import { createPopper } from '@popperjs/core'
import { get } from '@rails/request.js'

export default class extends Controller {
  static targets = ['element']

  connect() {
    const noResultsLabel = this.elementTarget.dataset.noResults
    const remoteUrl = this.elementTarget.dataset.url
    const create = this.elementTarget.dataset.create
    const isMultiple = this.elementTarget.multiple

    try {
      const config = {
        valueField: 'id',
        searchField: 'text',
        labelField: 'text',
        create: !!create,
        allowEmptyOption: false,
        render: {
          option: (data, _escape) => `<div>${!!data.html ? data.html : data.text}</div>`,
          item: (data, _escape) => `<div>${!!data.html ? data.html : data.text}</div>`,
          no_results: function(_data, _escape) {
            return `<div class="no-results">${noResultsLabel}</div>`;
          }
        },
        load: this.#loadRemoteData(remoteUrl),
        // make the dropdown responsive to open on top or bottom based on the position of the field
        // in the page, source: https://github.com/orchidjs/tom-select/discussions/163
        onInitialize: function() {
          this.popper = createPopper(this.control, this.dropdown)
        },
        onDropdownOpen: function() {
          this.popper.update()
        }
      }

      if (isMultiple) {
        config.plugins = ['remove_button']
      }

      this.tomSelect = new TomSelect(this.elementTarget, config)
    } catch (error) {
      console.error('Error initializing TomSelect:', error)
    }
  }

  disconnect() {
    this.tomSelect.destroy()
  }

  #loadRemoteData(remoteUrl) {
    if (!remoteUrl) return

    return (query, callback) => {
      if (query.length < 2) {
        return callback()
      }

      get(remoteUrl + `?q=${encodeURIComponent(query)}`)
        .then(response => response.json)
        .then(data => { callback(data.results) })
        .catch(_error => { callback() })
    }
  }
}
